<skl-dialog-content-ins [isReady]="isFormReady">
    <ins-header id="sale-document-payment-dialog-header">
        <ins-toolbar>
            <ins-title class="modal__title">
                <span class="align--tiny-right" id="sale-document-payment-dialog-header-title">
                    {{ 'scenes.shared.dialog.sale-document-payment-dialog.title' | translate}}
                </span>
                <a
                    class="document-payment-dialog__link link link--blue display--nowrap"
                    [tooltip]="data.entity.documentNumber"
                    id="sale-document-payment-dialog-header-document-number"
                    [routerLink]="viewModel?.getDocumentRouteObject()?.url! | sklCompanyLink"
                    [queryParams]="viewModel?.getDocumentRouteObject()?.params!">
                    {{ data.entity.documentNumber }}
                </a>
            </ins-title>
            <button
                slot="end"
                id="sale-document-payment-dialog-header-cancel-button"
                type="button"
                tabindex="-1"
                class="ins-close-btn"
                (click)="onCancel()">
                <skl-icon name="cross"></skl-icon>
            </button>
        </ins-toolbar>
    </ins-header>
    <ins-content>
        <skl-form-container>
            @if (viewModel && viewModel.bo) {
                <div class="grid" [sklValidationSource]="viewValidation">
                    <div class="col-1">
                        <div class="col-1-2">
                            <ins-form-field
                                [label]="'scenes.shared.dialog.sale-document-payment-dialog.form.date.label' | translate">
                                <ins-datepicker
                                    id="sale-document-payment-dialog-date"
                                    [(ngModel)]="viewModel.payment.date"
                                    [sklValidate]="'date.' + viewModel.payment.sun">
                                </ins-datepicker>
                            </ins-form-field>
                        </div>
                        <div class="col-1-2">
                            <ins-form-field
                                class="display--flex-auto"
                                [label]="'scenes.shared.dialog.sale-document-payment-dialog.form.price.label' | translate">
                                <ins-input
                                    inputmode="decimal"
                                    id="sale-document-payment-dialog-payment"
                                    [(ngModel)]="viewModel.payment.value"
                                    [precision]="viewModel.currency.precision"
                                    [sklValidate]="'value.' + viewModel.payment.sun">
                                </ins-input>
                                <div
                                    slot="end"
                                    id="sale-document-payment-dialog-preview-payment"
                                    [sklValidateInner]="{key: 'value.' + viewModel.payment.sun, option: 'disable'}">
                                    {{ viewModel.currency.symbol }}
                                </div>
                            </ins-form-field>
                        </div>
                        <div class="col-1">
                            <ins-checkbox
                                class="checkbox--flattened"
                                id="sale-document-payment-dialog-on-document"
                                [(ngModel)]="viewModel.payment.onDocument"
                                [sklValidate]="'onDocument.' + viewModel.payment.sun"
                                [label]="'scenes.shared.dialog.sale-document-payment-dialog.form.on-document.label' | translate">
                            </ins-checkbox>
                        </div>
                    </div>
                </div>
            }
        </skl-form-container>
    </ins-content>

    <ins-footer class="dialog__buttons">
        <skl-button
            id="sale-document-payment-dialog-cancel-button"
            (click)="onCancel()">
            {{ 'scenes.configuration.shared.base.dialog.buttons.cancel' | translate }}
        </skl-button>
        <skl-button
            id="sale-document-payment-dialog-confirm-button"
            typeName="accent"
            [spinner]="viewModel?.isSaving!"
            (click)="viewModel?.save()!">
            {{ 'scenes.configuration.shared.base.dialog.buttons.save' | translate }}
        </skl-button>
    </ins-footer>
</skl-dialog-content-ins>
